/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VendorErrorCodeResponseDto } from './VendorErrorCodeResponseDto';
import {
    VendorErrorCodeResponseDtoFromJSON,
    VendorErrorCodeResponseDtoFromJSONTyped,
    VendorErrorCodeResponseDtoToJSON,
    VendorErrorCodeResponseDtoToJSONTyped,
} from './VendorErrorCodeResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListVendorErrorCodesResponseDto
 */
export interface ListVendorErrorCodesResponseDto {
    /**
     * 
     * @type {Array<VendorErrorCodeResponseDto>}
     * @memberof ListVendorErrorCodesResponseDto
     */
    data: Array<VendorErrorCodeResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListVendorErrorCodesResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListVendorErrorCodesResponseDto interface.
 */
export function instanceOfListVendorErrorCodesResponseDto(value: object): value is ListVendorErrorCodesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListVendorErrorCodesResponseDtoFromJSON(json: any): ListVendorErrorCodesResponseDto {
    return ListVendorErrorCodesResponseDtoFromJSONTyped(json, false);
}

export function ListVendorErrorCodesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListVendorErrorCodesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(VendorErrorCodeResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListVendorErrorCodesResponseDtoToJSON(json: any): ListVendorErrorCodesResponseDto {
    return ListVendorErrorCodesResponseDtoToJSONTyped(json, false);
}

export function ListVendorErrorCodesResponseDtoToJSONTyped(value?: ListVendorErrorCodesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(VendorErrorCodeResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

